import { ProductType } from './ProductContext';
export var Flow;
(function (Flow) {
    Flow["last-minute"] = "last-minute";
    Flow["derniere-minute"] = "derniere-minute";
    Flow["flug"] = "flug";
    Flow["hotel"] = "hotel";
    Flow["urlaub"] = "urlaub";
    Flow["bahn-und-hotel"] = "bahn-und-hotel";
    Flow["vacances"] = "vacances";
})(Flow || (Flow = {}));
export var FlowRoutes;
(function (FlowRoutes) {
    FlowRoutes["last-minute"] = "package";
    FlowRoutes["super-last-minute"] = "superlastminute";
    FlowRoutes["hotel"] = "hotel";
    FlowRoutes["bahn-und-hotel"] = "bahnundhotel";
    FlowRoutes["flug"] = "flug";
    FlowRoutes["urlaub"] = "package";
    FlowRoutes["vacances"] = "package";
})(FlowRoutes || (FlowRoutes = {}));
export var flowContextMap = new Map([
    [Flow['last-minute'], {
            productType: ProductType.PACKAGE,
            productChannel: 'DEFAULT'
        }],
    [Flow['derniere-minute'], {
            productType: ProductType.PACKAGE,
            productChannel: 'DEFAULT'
        }],
    [Flow.urlaub, {
            productType: ProductType.PACKAGE,
            productChannel: 'DEFAULT'
        }],
    [Flow.vacances, {
            productType: ProductType.PACKAGE,
            productChannel: 'DEFAULT'
        }],
    [Flow.flug, {
            productType: ProductType.FLIGHT,
            productChannel: 'DEFAULT'
        }],
    [Flow.hotel, {
            productType: ProductType.HOTEL,
            productChannel: 'DEFAULT'
        }],
    [Flow['bahn-und-hotel'], {
            productType: ProductType.RAIL_PACKAGE,
            productChannel: 'DEFAULT'
        }],
]);
export default Flow;
